import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import Icon from '../../../../../../Icon';

import styles from './index.styl';

const LabTestResultDetailsCardDocuments = ({
  loggingView,
  formatMessage,
  resultDocument = [],
}) => {
  const globalDocument = get(resultDocument, '[0]', {});
  const hasReferenceToPdf = !!globalDocument.files;

  const handleOpenDocument = file => {
    loggingView(get(file, 'documentUid'));
    window.open(get(file, 'files[0].url'));
  };

  return (
    <div className={styles.documentsRoot}>
      <div className={styles.documentsTitle}>
        {formatMessage({
          id: 'common.documents',
        })}
      </div>
      {hasReferenceToPdf ? (
        resultDocument.map(document => {
          return (
            <div
              key={document.documentUid}
              className={styles.documentWrapper}
              onClick={() => handleOpenDocument(document)}
            >
              <Icon
                size={32}
                name="icon-document-black"
                className={styles.documentIcon}
              />
              <div className={styles.documentName}>{document.title || ''}</div>
            </div>
          );
        })
      ) : (
        <div className={styles.notification}>
          {formatMessage({
            id: 'patient.portal.labTestResult.availablePdfIvy',
          })}
        </div>
      )}
    </div>
  );
};

LabTestResultDetailsCardDocuments.propTypes = {
  resultDocument: PropTypes.array,
  formatMessage: PropTypes.func,
  loggingView: PropTypes.func,
};

export default LabTestResultDetailsCardDocuments;



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/Card/LabTestResultCard/LabTestResultDetailsCard/LabTestResultDetailsCardDocuments.jsx